import { render, staticRenderFns } from "./ParameterizedManagement.vue?vue&type=template&id=572f4cb3&scoped=true&"
import script from "./ParameterizedManagement.vue?vue&type=script&lang=js&"
export * from "./ParameterizedManagement.vue?vue&type=script&lang=js&"
import style0 from "./ParameterizedManagement.vue?vue&type=style&index=0&id=572f4cb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f4cb3",
  null
  
)

export default component.exports